import { Card, CardContent, Grid, Typography } from '@mui/material'

const CardView = (props) => {
  return(
    <>
      <Grid container >
      {
        props.data.map( (item) => {
          return (
            <Grid key={item.title} item sm={4} md={3} sx={{m:3}}>
            <Card  sx={{width:'300px'}}>
              <CardContent>
                <Typography variant="h5">{item.title}</Typography>
                <Typography variant="h2">{item.value}</Typography>
              </CardContent>
            </Card>
            </Grid>
          );
        })
      }
      </Grid>
    </>
  )
}

export default CardView;